import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";
import Field from "@/components/Field";

interface SurveyConfigurationProps {
  className?: string;
}

export default function SurveyConfiguration({
  className,
}: SurveyConfigurationProps) {
  const { t } = useTranslation();
  return (
    <section
      className={cn(className, "flex flex-col gap-4 place-content-start")}
    >
      <Field
        name="name"
        label={t("surveyEditor.questionnaireName")}
        render={({ field }) => <Input className="min-w-96 w-1/2" {...field} />}
      />
      <Field
        name="description"
        label={t("surveyEditor.questionnaireDescription")}
        render={({ field }) => (
          <Textarea className="min-w-96 w-1/2" {...field} />
        )}
      />
    </section>
  );
}
